import React, { PropsWithChildren } from 'react'

const ModuleIconSelectorContainer: React.FC <PropsWithChildren<any>> = ({ children }) => {

    return <div className = "moduleIconSelectorContainer">{children}</div>

}

export default ModuleIconSelectorContainer